import { Stack, Text, Button, Link, useToast } from "@chakra-ui/react";
import { Link as ReactLink, useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import { POST } from "../../utils/ApiRequestProvider";
import { useSelector } from "react-redux";

import { BASE_URL_REDIRECT } from "../../config";
import InputWithErrorMessage from "../../components/Inputs/InputWithErrorMessage";

export default function Register() {
    const toast = useToast();
    const navigate = useNavigate();
    const [isLoading] = useState(false);
    const [errored, setErrored] = useState(false);

    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        password: '',
        confirmPassword: '',
        redirectURL: `${BASE_URL_REDIRECT}/verify`
    });

    const user = useSelector((state: any) => state.user.value);

    useEffect(() => {
        if (user?.role) navigate("/");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    async function handleSignUpClick() {
        try {
            const res = await POST('/api/user/register',
                formData
            );
            toast({
                title: res.message,
                status: res.status,
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });

            if (res.status === 'success') navigate('/login');
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
    }

    return (
        <Stack
            w={'full'}
            h={"100vh"}
            justify={'center'}
            align={"center"}
            py={32}
        >
            <Text mb={2} fontSize='3xl' color='textColor.headingColor' fontWeight={'bold'}>
                Register your account
            </Text>
            <Text mb={2} fontSize={'md'} color='textColor.supportingText' fontWeight={'normal'}>
                Already have an account?&nbsp;
                <Link color={'primary.400'} as={ReactLink} to={'/login'}>
                    Login
                </Link>
            </Text>
            <Stack spacing={3} w={'md'} boxShadow={'base'} p={6} rounded={'2xl'}>
                <InputWithErrorMessage
                    placeholder="Full Name"
                    errorMessage="Full Name is required!"
                    required={true}
                    value={formData.fullName}
                    onChange={(e) => setFormData({ ...formData, fullName: e.target.value })}
                    errorStatus={setErrored}
                />
                <InputWithErrorMessage
                    placeholder="Email Address"
                    errorMessage={"Please enter a valid email address!"}
                    required={true}
                    value={formData.email}
                    validationPattern={/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    errorStatus={setErrored}
                />
                <InputWithErrorMessage
                    required={true}
                    type={"password"}
                    value={formData.password}
                    placeholder="Password"
                    validationPattern={/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/}
                    errorMessage={"Password must be at least 8 characters with at least one uppercase letter, numeric value and a symbol."}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    errorStatus={setErrored}
                />

                <InputWithErrorMessage
                    placeholder="Confirm Password"
                    type={"password"}
                    validationPattern={/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/}
                    errorMessage={"Password's doesn't match"}
                    value={formData.confirmPassword}
                    compare={formData.password}
                    onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                    errorStatus={setErrored}
                />
                <Button
                    bgGradient="linear(to-r, primary.400, primary.500)"
                    color="white"
                    rounded={"full"}
                    fontWeight={"400"}
                    fontSize={`sm`}
                    _hover={{ bgGradient: "linear(to-r, primary.500, primary.600)" }}
                    _active={{ bgGradient: "linear(to-r, primary.700, primary.800)" }}
                    size={'md'}
                    w={"full"}
                    onClick={handleSignUpClick}
                    isLoading={isLoading}
                    disabled={errored}
                >
                    Register Now!
                </Button>
            </Stack>
        </Stack>
    )
}
